// extracted by mini-css-extract-plugin
export default {"content_loading":"privacy-policy_content_loading__4wfpX","policy":"privacy-policy_policy__YeRzB","error_message":"privacy-policy_error_message__0qgZg"};